import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { copyBlobToClipboard } from 'copy-image-clipboard'




@Component({
  selector: 'app-map-preview',
  templateUrl: './map-preview.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})

export class MapPreviewComponent implements OnInit {
  @Input() imageData: string;
  @Input() pngImageBlob: Blob
  constructor(
    private bsModalRef : BsModalRef
  ) { }

  ngOnInit(): void {
  }
  cancel(){
    this.bsModalRef.hide();
  }

  copyToClipBoard(){
    copyBlobToClipboard(this.pngImageBlob)
  }


}
